import { useStaticQuery, graphql } from "gatsby";

export const Content = () => {
  return useStaticQuery(graphql`
    {
      allStrapiPage(filter: { name_: { eq: "INDUSTRIES" } }) {
        nodes {
          # seo
          seo {
            id
            title
            keywords {
              data{
                keywords
              }
            }
            description {
              data {
                description
              }
            }
            
          }

          # section title
          section_title_description {
            name_
            title
            description
          }

          # featured block
          featured_block {
            name_
            title
            content {
              data{
                content
              }
            }
            image_alt {
              data{
                image_alt
              }
            }
            image {
              id
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
          }

          # featured item card
          featured_item_card {
            name_
            title
            button_text
            button_link
            background_image {
              id
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
            label
          }

          # multi item block title
          multi_item_block_title {
            title
          }

          # multi item block items
          multi_item_block_items {
            name_
            title
          }
          # content_block 
          content_block {
            name_
            title
          }
          # cta block
          cta_block {
            title
            content {
              data{
                content
              }
            }
            button_link
            button_text
          }
          locale
        }
        pageInfo {
          perPage
        }
      }
    }
  `);
};
